import type { createBrowserRouter } from 'react-router-dom';

type AppRouter = ReturnType<typeof createBrowserRouter>;

let router: AppRouter | null = null;

export const setRouter = (instance: AppRouter): void => {
  router = instance;
};

export const navigateTo = (url: string): void => {
  router?.navigate(url);
};

export const replaceWith = (url: string): void => {
  router?.navigate(url, { replace: true });
};
